import React from 'react';
import { ServiceDetailPage } from './ServiceDetailPage';



export const IngenieriaEstructural: React.FC = () => {
  const serviceData = {
    title: 'Ingeniería Estructural',
    description: 'Promovemos el uso de sistemas constructivos y materiales innovadores que optimizan los procesos de construcción, asegurando mayor eficiencia y calidad. Estos avances son el complemento perfecto para nuestra área de Mecánica de Suelos, garantizando proyectos sólidos y bien fundamentados desde su inicio.',
    image: '/services/Ser_Int_Estructuras.jpg',
    sections: [
      
      {
        title: 'Tipos de Proyectos Desarrollados:',
        subsections: [
          {
            title: 'Edificación',
            items: [
              'Casa habitación',
              'Edificios de departamentos',
              'Plazas comerciales',
              'Naves industriales',
              'Vías terrestres'
            ]
          },
          {
            title: 'Infraestructura',
            items: [
              'Puentes',
              'Obras de drenaje',
              'Pasos Vehiculares'
            ]
          }
        ]
      },
      
    ]
  
  };

  return <ServiceDetailPage {...serviceData} />;
};
